import React from 'react';
import { oneOfType } from 'prop-types';
import { t } from 'i18next';
import cn from 'classnames';

import CollapsibleWrapper from '~components/CollapsibleWrapper';
import { itemPropTypes } from '~propTypes/shoppingCart';
import { offerPropTypes } from '~propTypes/offerCompletions';

import styles from './styles.module.scss';
import { useProductDetail } from './hooks/useProductDetail';
import { getIngredientsWithAction } from './utils';

function ProductDetail({ item }) {
  const { showVariantName, isComplement, isOffer, isCustomPizza, collapsibleContent, baseIngredients } =
    useProductDetail(item);

  return (
    <div
      className={cn(styles.container, { [styles.hasCollapsible]: !showVariantName && !collapsibleContent })}>
      {!isOffer && (
        <div className={styles.detail}>
          {showVariantName && (
            <span className={cn(styles.title, { [styles.complement]: isComplement })}>
              {item?.variantName}
            </span>
          )}
          {!isCustomPizza && <span>{getIngredientsWithAction(item?.ingredients, baseIngredients)}</span>}
        </div>
      )}
      {!!collapsibleContent && (
        <CollapsibleWrapper
          title={t('ProductDetail:detail')}
          contentContainerClassName={styles.contentContainer}
          className={styles.collapsiContainer}>
          {collapsibleContent}
        </CollapsibleWrapper>
      )}
    </div>
  );
}

ProductDetail.propTypes = {
  item: oneOfType([itemPropTypes, offerPropTypes])
};

export default ProductDetail;
